﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconShirt } from "@tabler/icons-react";

export const TallesLetrasIcon = IconShirt;
export const TallesLetrasHelpText = '* Aquí puede ver la lista de talles de prendas para el torso.'

export class catTallesConLetras extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TallesConLetras";
        this.def.columns.c_category_id.defaultValue = "TallesConLetras";
        this.Title = "Talles con Letras";
        this.Icon = TallesLetrasIcon;
        this.HelpText = TallesLetrasHelpText;
    }
}